var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('iframe',{staticStyle:{"height":"500px","width":"100%"},attrs:{"src":'https://vc3.sunnah.live/playback/presentation/2.3/' + _vm.slide,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }